import {Box, CssBaseline} from '@mui/material'
import type {FC, ReactElement} from 'react'
import {StrictMode, useCallback} from 'react'
import MBAIMainDrawer from './drawer/Drawer'

interface MBAIMainSideMenuProps {
  open: boolean
  onMenuOpen: () => void
  isMobile?: boolean
}

const MBAIMainSideMenu: FC<MBAIMainSideMenuProps> = ({
  onMenuOpen,
  open,
  isMobile = false,
}): ReactElement => {
  const toggleDrawer = useCallback(() => {
    onMenuOpen()
  }, [onMenuOpen])

  return (
    <StrictMode>
      <Box sx={{display: 'flex'}} data-testid="mbai-main-layout-component">
        <CssBaseline />
        <MBAIMainDrawer open={open} onDrawerOpen={toggleDrawer} isMobile={isMobile} />
      </Box>
    </StrictMode>
  )
}

export default MBAIMainSideMenu
